/*
 * READ MORE on a blog index: fetch the next page of this blog (or tag page)
 * and append its tiles, instead of leaving the page. Without this script
 * the button is a link to that next page.
 */
const grid = document.querySelector('[data-circles-blog-index]');
const button = document.querySelector('[data-circles-blog-index-more]');

if (grid instanceof HTMLElement && button instanceof HTMLAnchorElement && !button.dataset.bound) {
  button.dataset.bound = 'true';

  button.addEventListener('click', async (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    if (grid.getAttribute('aria-busy') === 'true') return;

    grid.setAttribute('aria-busy', 'true');
    button.classList.add('disabled');
    try {
      // The next page is this theme's own markup on this store's origin.
      const response = await fetch(button.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const tiles = Array.from(doc.querySelectorAll('[data-circles-blog-index] > .news-tile'), (tile) =>
        document.importNode(tile, true)
      );
      grid.append(...tiles);
      tiles[0]?.querySelector('a')?.focus({ preventScroll: true });

      const next = doc.querySelector('[data-circles-blog-index-more]');
      if (next instanceof HTMLAnchorElement) button.href = next.href;
      else button.closest('.editorial-footer')?.remove();
    } catch {
      window.location.href = button.href;
    } finally {
      grid.setAttribute('aria-busy', 'false');
      button.classList.remove('disabled');
    }
  });
}
